function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.8597 29.1346C9.86896 29.3849 10.0729 29.5826 10.3231 29.5826C10.3293 29.5826 10.3354 29.5826 10.3416 29.5826C10.5981 29.5733 10.7958 29.3571 10.7865 29.1037C10.561 22.9156 14.5896 17.4751 20.58 15.8686C27.6208 13.981 34.8841 18.1764 36.7717 25.2141C37.0961 26.4314 37.2506 27.6826 37.2228 28.9307C37.2166 29.1872 37.4205 29.3972 37.6769 29.4034H37.6862C37.9364 29.4034 38.1434 29.2026 38.1496 28.9493C38.1774 27.6115 38.0168 26.2738 37.6677 24.9732C35.6472 17.4411 27.8772 12.9522 20.3421 14.9696C13.9315 16.6873 9.62181 22.5109 9.86279 29.1346H9.8597Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1774 12.4363C19.233 12.6433 19.4215 12.7792 19.6254 12.7792C19.6655 12.7792 19.7057 12.773 19.7459 12.7637C19.993 12.6989 20.1382 12.4424 20.0733 12.1953L18.2382 5.34293C18.1733 5.09578 17.9169 4.95057 17.6698 5.01545C17.4226 5.08033 17.2774 5.33675 17.3423 5.58391L19.1774 12.4363Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7257 17.0148C11.8153 17.1044 11.9358 17.1507 12.0532 17.1507C12.1706 17.1507 12.2911 17.1044 12.3807 17.0148C12.563 16.8325 12.563 16.539 12.3807 16.3598L7.36652 11.3457C7.18424 11.1634 6.89075 11.1634 6.71156 11.3457C6.53237 11.528 6.52928 11.8215 6.71156 12.0007L11.7257 17.0148Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68162 24.726C7.88552 24.726 8.074 24.5901 8.12961 24.3831C8.19449 24.1359 8.04927 23.8826 7.80211 23.8146L0.949777 21.9795C0.705712 21.9146 0.449262 22.0598 0.381294 22.307C0.316416 22.5541 0.461638 22.8075 0.708792 22.8755L7.56113 24.7106C7.60129 24.7198 7.64146 24.726 7.68162 24.726Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6187 22.307C47.5538 22.0598 47.3005 21.9146 47.0503 21.9795L40.1979 23.8146C39.9507 23.8795 39.8055 24.1359 39.8704 24.3831C39.926 24.5901 40.1145 24.726 40.3184 24.726C40.3585 24.726 40.3987 24.7198 40.4389 24.7106L47.2912 22.8755C47.5384 22.8106 47.6836 22.5541 47.6187 22.307Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9468 17.1507C36.0642 17.1507 36.1847 17.1044 36.2743 17.0148L41.2916 12.0007C41.4738 11.8184 41.4738 11.5249 41.2916 11.3457C41.1093 11.1665 40.8158 11.1634 40.6366 11.3457L35.6194 16.3598C35.4371 16.5421 35.4371 16.8356 35.6194 17.0148C35.709 17.1044 35.8294 17.1507 35.9468 17.1507Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2511 12.7637C28.2912 12.773 28.3314 12.7792 28.3716 12.7792C28.5755 12.7792 28.7639 12.6433 28.8195 12.4363L30.6546 5.587C30.7195 5.33984 30.5743 5.08651 30.3272 5.01854C30.08 4.95366 29.8267 5.09887 29.7587 5.34602L27.9236 12.1953C27.8587 12.4424 28.0039 12.6958 28.2511 12.7637Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0184 31.2138H1.98165C1.72523 31.2138 1.51823 31.4208 1.51823 31.6772C1.51823 31.9337 1.72523 32.1407 1.98165 32.1407H46.0184C46.2748 32.1407 46.4818 31.9337 46.4818 31.6772C46.4818 31.4208 46.2748 31.2138 46.0184 31.2138Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3535 38.4554H24.9917C24.7353 38.4554 24.5283 38.6624 24.5283 38.9189C24.5283 39.1753 24.7353 39.3823 24.9917 39.3823H38.3535C38.6099 39.3823 38.8169 39.1753 38.8169 38.9189C38.8169 38.6624 38.6099 38.4554 38.3535 38.4554Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3436 35.298C31.3436 35.0416 31.1366 34.8346 30.8802 34.8346H9.61253C9.3561 34.8346 9.14911 35.0416 9.14911 35.298C9.14911 35.5545 9.3561 35.7615 9.61253 35.7615H30.8802C31.1366 35.7615 31.3436 35.5545 31.3436 35.298Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3197 42.0732H15.7049C15.4485 42.0732 15.2415 42.2802 15.2415 42.5366C15.2415 42.793 15.4485 43 15.7049 43H35.3197C35.5761 43 35.7831 42.793 35.7831 42.5366C35.7831 42.2802 35.5761 42.0732 35.3197 42.0732Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCse);
export default __webpack_public_path__ + "static/media/CSE.4b3638a852cc78d93529b554b8dc33a2.svg";
export { ForwardRef as ReactComponent };